
import {Component, Vue, Prop } from 'vue-property-decorator';
import { getDateByTimeZoneOffset } from '@common/dateTimeHelper';
import { Element } from '@api/models/Element';
import { contains } from '@service/helpers/domHelper';
import { RootState } from '@service/store/types/RootState';

@Component({})
export default class TimeCardBase extends Vue {

    @Prop() source: Element;
    @Prop( {default: ""} ) buttonTitle: string;

    readonly base_class = "time-card";
    readonly container_class = "time-card__container";
    readonly main_class = "time-card__main";
    readonly content_class = "time-card__content";
    readonly top_class = "time-card__top";
    readonly title_class: string = "time-card__title";
    readonly type_class = "time-card__type";
    readonly time_class = "time-card__time";
    readonly footer_class = "time-card__footer";

    deleted = false;

    play(event: MouseEvent) {
        const $footer = (this.$refs.footer as Vue | undefined)?.$el as HTMLElement | null;

        if(!contains($footer, event.target as HTMLElement)) {
            this.$emit('play', this.source);
        }
    }

    get type() {
        return this.source.type || this.$t(`program.sessionWithoutArticle`).toString()
    }

    get deletedClass() {
        return this.deleted ? 'time-card_deleted' : '';
    }

    get selectedTimeZoneOffset() {
        return (this.$store.state as RootState).selectedTimeZoneOffset;
    }

    get timeStart(): string {
        return getDateByTimeZoneOffset(this.source.beginAt, this.selectedTimeZoneOffset).toFormat("HH:mm") || "";
    }

    get timeEnd() {
        return getDateByTimeZoneOffset(this.source.endAt, this.selectedTimeZoneOffset).toFormat("HH:mm") || "";
    }
}

